<template>
  <div>
    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("wiseweb") }}</h4>
        </div>
      </div>
    </div>

    <div class="grab h4wrap">
      <!--<img src="/static/img/wise_img.jpg">-->
      <div class="border_dashed_b mt_30">
        <h5 class="h5_title">{{ $t("datewise_title") }}</h5>
        <h6 class="h6_title" style="margin-top: 20px">{{ $t("datewise_1_title") }}</h6>
        <ul class="ul_list">
          <li>{{ $t("datewise_1_detail_1") }}</li>
          <li>{{ $t("datewise_1_detail_2") }}</li>
          <li>{{ $t("datewise_1_detail_3") }}</li>
        </ul>

        <h6 class="h6_title" style="margin-top: 20px">{{ $t("datewise_2_title") }}</h6>
        <ul class="ul_list">
          <li>{{ $t("datewise_2_detail_1") }}</li>
          <li>{{ $t("datewise_2_detail_2") }}</li>
          <li>{{ $t("datewise_2_detail_3") }}</li>
          <li>{{ $t("datewise_2_detail_4") }}</li>
          <li>{{ $t("datewise_2_detail_5") }}</li>
          <li>{{ $t("datewise_2_detail_6") }}</li>
          <li>{{ $t("datewise_2_detail_7") }}</li>
        </ul>
        <button class="location_btn" style="margin-left: 24px; margin-top: 16px" onclick="window.open('./static/data.pdf')">관련자료 다운로드</button>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'DataWise'
  }
</script>



// WEBPACK FOOTER //
// src/components/DataWise.vue